export const GOOGLE_LOGIN_KEY = "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";
export const Google_Login_Client_ApiKey =
  "35902553107-l55686hi262gjm8lo42ns3c1cve3cmbn.apps.googleusercontent.com"; //EventPrixWeb_Dev
export const GoogleAddressAutoCompleteKey =
  "AIzaSyByM94LkveuzXSRfgWueJAQ7l3Kv41leRw"; //EventPrixWeb_Dev
export const TimeZoneApiKey = "AIzaSyByM94LkveuzXSRfgWueJAQ7l3Kv41leRw";
export const marginBottomSize = "30px";
export const stripePublishableKey = "pk_live_51SlKriCVs2QDY9jGg3utIIye1duetS4ZaDKLkejYXI2t6ErKyBpJBtAx418jGmvs1ioqU2bdWHeAXNzfoZGJSsce00Pl8i67oF";


export const defaultState = {
  CheckOutData: {},
  paymentOption: {
    IsHost: false,
    IsStripe: false,
    IsZelle: false,
    hosttext: "",
  },
};
